import styled from 'styled-components';
import { getEasing } from '../../utils/getEasing';
import { injectTypography } from '../../utils/injectTypography';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectInteractionBar } from '../../utils/injectInteractionBar';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
const getFieldBorderColor = ({ props, theme, hover, }) => {
    if (props.disabled)
        return theme.colors.form.muted.secondary;
    if (props.invalid)
        return theme.colors.form.error;
    if (hover)
        return theme.colors.form.strong;
    return theme.colors.form.tertiary;
};
export const StyledContainer = styled.div `
  padding-top: 0.8125em;
  padding-top: ${(props) => !props.empty && '0'};
  &:focus-within {
    padding-top: 0;
  }

  cursor: ${(props) => props.disabled && 'not-allowed'};

  transition: padding 0.25s ${getEasing};

  ${injectSpacing('margin')}
`;
export const StyledInnerContainer = styled.div `
  border-color: ${(props) => getFieldBorderColor({ props, theme: props.theme, hover: false })};
  border-style: solid;
  border-width: 1px;
  &:hover {
    border-color: ${(props) => getFieldBorderColor({ props, theme: props.theme, hover: true })};
  }

  border-bottom: none;

  transition-timing-function: ${getEasing};
  transition-duration: 0.25s;
  transition-property: border-color, padding;

  ${injectInteractionBar}
`;
export const StyledTextAreaContainer = styled.div `
  padding: var(${(props) => props.theme.responsive.spacing.s});
`;
export const StyledTextArea = styled.textarea `
  all: revert;

  display: block;
  box-sizing: border-box;
  width: 100%;
  padding-top: ${(props) => !props.empty && '0.8125em'};

  background-color: transparent;
  border: none;

  cursor: ${(props) => props.disabled && 'not-allowed'};

  transition: padding 0.25s ${getEasing};

  resize: vertical;

  &:focus {
    padding-top: 0.8125em;
  }

  &:disabled {
    color: ${(props) => props.theme.colors.form.muted.primary};
  }

  ${(props) => injectTypography(props, 'copy1')}
  ${injectOSXFontSmoothing(true)}
`;
//# sourceMappingURL=TextArea.styles.js.map